<template>
  <v-row no-gutters class="post-media">
    <v-col cols="12" class="mediaGrid">
      <div
        v-for="(media, index) in mediaListFiltered"
        :key="index"
        :class="['block', generateMediaBlock(index)]"
      >
        <template v-if="index < 5">
          <v-img
            v-if="media.type == MEDIA_TYPE_PHOTO"
            :src="media.thumbnail || media.path"
            :position="'center center'"
            width="100%"
            height="100%"
            cover
            @click="
              $store.commit('openMediaView', {
                idModel: index,
                currentRoute: $route,
                mediaId: media.id,
                mediaType: 'photo',
                parentType: parent.type,
                parentId: parent.id,
                listMedia: mediaAll,
              })
            "
          />
          <div
            v-else-if="media.type == MEDIA_TYPE_YOUTUBE"
            class="mediaGrid-iframe"
            style="position: relative"
          >
            <div class="footer-media" :class="isShowIframe ? 'd-none' : 'd-block' ">
              <MediaFooter
                :isHide="isShowIframe"
                :value="media.meta"
                :responsive="mediaListFiltered.length"
              />
            </div>
            <iframe
              v-if="isShowIframe"
              allow="autoplay"
              allowfullscreen
              type="text/html"
              width="100%"
              height="360"
              :src="`https://www.youtube.com/embed/${media.youtubeId}?autoplay=1`"
              frameborder="0"
            />
            <v-img
              v-else
              class="pointer"
              :src="media.thumbnail || media.path"
              :position="'center center'"
              :width="'100%'"
              :height="'100%'"
              cover
              @click="isShowIframe = true"
            >
              <div class="d-flex align-center justify-center fill-height">
                <div class="buttons" style="z-index: 1">
                  <v-btn color="rgba(255,255,255,.6)" fab icon>
                    <v-icon size="73">fal fa-circle-play</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-img>
          </div>
        </template>
        <template v-if="mediaAll.length > 5 && index == 4">
          <div
            class="mediaGrid-extend"
            @click="
              $store.commit('openMediaView', {
                idModel: index,
                currentRoute: $route,
                mediaId: mediaAll[index].id,
                mediaType: 'photo',
                parentType: parent.type,
                parentId: parent.id,
                listMedia: mediaAll,
              })
            "
          >
            + {{ mediaAll.length - 5 }}
          </div>
        </template>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import MediaFooter from "./MediaFooter";
export default {
  props: {
    mediaList: {
      type: Array,
      default: () => [],
    },
    parent: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    MediaFooter,
  },
  data() {
    return {
      isShowIframe: false,
      mediaAll: [],
    };
  },
  computed: {
    mediaListFiltered() {
      const mediaList = [];
      this.mediaList.forEach((media) => {
        if (media.type == MEDIA_TYPE_YOUTUBE) {
          mediaList.push(media);
        }
      });
      this.mediaList.forEach((media) => {
        if (media.type == MEDIA_TYPE_PHOTO) {
          mediaList.push(media);
        }
      });

      this.mediaAll = mediaList;

      return mediaList.slice(0, 5);
    },
  },
  methods: {
    generateMediaBlock(index) {
      switch (this.mediaListFiltered.length) {
        case 1:
          return "frame-12x6";
        case 2:
          switch (index) {
            case 0:
              return "frame-6x12";
            case 1:
              return "frame-6x12";
          }
        case 3:
          switch (index) {
            case 0:
              return "frame-8x8";
            case 1:
              return "frame-4x4";
            case 2:
              return "frame-4x4";
          }
        case 4:
          switch (index) {
            case 0:
              return "frame-9x9";
            case 1:
              return "frame-3x3";
            case 2:
              return "frame-3x3";
            case 3:
              return "frame-3x3";
          }
        case 5:
          switch (index) {
            case 0:
              return "frame-6x6";
            case 1:
              return "frame-6x6";
            case 2:
              return "frame-4x4";
            case 3:
              return "frame-4x4";
            case 4:
              return "frame-4x4";
          }
      }
    },
    redirectLocation(media) {
      console.log("media: ", media);
    },
  },
};
</script>
<style lang="scss">
.footer-media {
  position: absolute;
  bottom: 0;
  background: rgb(34, 34, 34); /* for IE */
  background: rgba(34, 34, 34, 0.75);
  z-index: 2;
  width: 100%;
}
@-webkit-keyframes skeleton-loading {
  from {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
}

@keyframes skeleton-loading {
  from {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
}
.post-media {
  .v-image__image {
    z-index: 1;
  }
  .v-responsive__sizer {
    z-index: 1;
    position: relative;
    background: #f1f1f1;
  }
  .v-responsive__sizer:before {
    content: "";
    -webkit-animation: skeleton-loading 1.3s infinite;
    animation: skeleton-loading 1.3s infinite;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    z-index: 1;
    /*
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(transparent),
      color-stop(rgba(255, 255, 255, 0.8)),
      to(transparent)
    );
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.8),
      transparent
    );
    */
  }
  .fa-play {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -12px;
    margin-left: -6px;
    z-index: 1;
    color: #fff;
  }
  .frame-8x8 > div {
    height: 100%;
  }
}
</style>